
export const getReports = state => state.get('reports').toJS();